// save image https://stackoverflow.com/questions/62576196/how-to-extract-the-detected-faces-from-face-api-js


// draw on canvas
//https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Applying_styles_and_colors

import React, { useState, useEffect, useContext,useRef } from 'react';

import { ReadingsContext } from '../SinusDemo2';
import { debugdiv, useMountEffect } from '../ODevice';
//import SinusDemo from '../SinusDemo';
// react tricks https://react-hookz.github.io/web/?path=/docs/lifecycle-usemounteffect--example


function DisplayData() {   

  const [debugvisible, setDebugvisible] = useState(true);
  const functionname ='DisplayData';
  const refDebugDiv = useRef();

    // Only run once while after mounting
    useMountEffect(()=>{
      console.log( functionname  + '  is loaded');
      if (debugvisible) {
        refDebugDiv.current.style.display = 'unset';
      } else {
        refDebugDiv.current.style.display = 'none';
      }
  });

  const handleChangeChkDebug = event =>{
    console.log('clicked');
    if (event.target.checked) {
        console.log('✅ Checkbox is checked');
        refDebugDiv.current.style.display = 'unset';
      } else {
        console.log('⛔️ Checkbox is NOT checked');
        refDebugDiv.current.style.display = 'none';
      }
      setDebugvisible(debugvisible => !debugvisible);
    };

  var readings = useContext(ReadingsContext);

    const [ProgramStartTime, setisProgramStartTime] = useState(0);
    const [ProgramCurrentTime, setisProgramCurrentTime] = useState(0);
    const [seconds, setSeconds] = useState(0);

    
    // Only run once while after mounting
    useMountEffect(()=>{
      setisProgramStartTime(Math.round((new Date()).getTime()))
    });

    //create a trigger on seconds 
    useEffect(() => {
      const interval = setInterval(() => {
        setSeconds(seconds => seconds + 1);
        setisProgramCurrentTime(Math.round((new Date()).getTime()));
        //console.log(readings);
      }, 1000);
      return () => clearInterval(interval);
    }, []);   

    return (
        <div>
          <div style={debugdiv}>
              <input type="checkbox" defaultChecked={debugvisible} onChange={ handleChangeChkDebug } />&nbsp;
              <b>{ functionname }</b> 
          </div>
          <div ref={refDebugDiv} >
          
          <div className="container">
              <div className="row">
                <div className="col">
                Program Start Time: { ProgramStartTime }   
                </div>
                <div className="col">
                Program running time: { ProgramCurrentTime } 
                </div>
                <div className="col">
                Program Run Time in seconds: { seconds }   
                </div>
                <div className="col">&nbsp;                  
                </div>
                <div className="col">
                cosinus wave  { readings.lastReading.simulation_stream_2 }   
                </div>
                <div className="col">
                sinus wave  { readings.lastReading.simulation_stream_1 }
                </div>
                <div className="col">&nbsp;                  
                </div>
                <div className="col">
                cosinus data wave  { readings.lastReading.stream_2 }   
                </div>
                <div className="col">
                sinus data wave  { readings.lastReading.stream_1 }
                </div>
                <div className="col">&nbsp;
                
                </div>
                <div className="col">
                  millis from sinuswave: { readings.lastReading.milliseconds } 
                </div>
              </div>
            </div>
          </div>

            

        </div>
    );
};

export default DisplayData;